import { render, staticRenderFns } from "./Voters.vue?vue&type=template&id=b2ff111a&"
import script from "./Voters.vue?vue&type=script&lang=js&"
export * from "./Voters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports